module.exports = __webpack_public_path__ + "app/bento-components/blog-river/media/icon.svg?7dfc335eb2fd31e931124ee227c88b29";